export default __webpack_public_path__ + "static/media/checkedBox.184d1341.svg";